module.exports = __webpack_public_path__ + "static/assets/020b1eb950ca25a0e74cbb17f975f3c8.png";